module.exports = __webpack_public_path__ + "img/pic02@2x.203cedb4.png";